import React, { useEffect, useState } from "react";
import "./timer.css";
import { connect } from "react-redux";
import api from "../../../api";
import SubmitStatus from "../../../components/submitloader";
import IitSectionTimer from "./iitsectiontimer";
import { submitTestApi } from "../../../services/saveAndNext";

import IitSectionTimer2 from "./iitSectionTimer2";

const Timer = (props) => {
  const [leftTimeSubmit, setLeftTimeToSubmit] = useState(-2);
  const [allSection, setAllSection] = useState([]);
  const [showTimerJSX, setShowTimerJSX] = useState(false);

  const [timerText, setTimerText] = useState("");

  const startTimer = (initTime) => {
    let timeLeft = initTime;
    const interval = setInterval(() => {
      timeLeft -= 1;
      const timerStr =
        Math.floor(timeLeft / 3600) +
        " : " +
        ("0" + (Math.floor(timeLeft / 60) % 60)).slice(-2) +
        " : " +
        ("0" + (timeLeft % 60)).slice(-2);
      setTimerText(timerStr);
      setLeftTimeToSubmit(timeLeft);
      sessionStorage.setItem("leftTimeToSubmit", timeLeft);
      if (timeLeft <= 0) {
        clearInterval(interval);
        submitTestApi(props);
      }
    }, 1000);
  };

  const ServerTime = (overrideTimestamp = null) => {
    const test = props.state.test_data;
    const attempt = props.state.attempt_data;
    const testType = test?.test_type_id;

    const processTime = (server_ts) => {
      let leftTime;

      if (!attempt) {
        if (testType === 1) {
          const expireTime = parseInt(test.test_end_timestamp) - server_ts;
          leftTime = parseInt(test.duration) > 0
            ? Math.min(parseInt(test.duration) * 60, expireTime)
            : -2;
        } else if (testType === 2) {
          leftTime = parseInt(test.duration) > 0
            ? parseInt(test.duration) * 60
            : 0;
        } else {
          leftTime = parseInt(test.test_end_timestamp) - server_ts;
        }
      } else {
        if (testType > 2) {
          leftTime = parseInt(attempt.test_end_timestamp) - server_ts;
        } else if (testType === 1) {
          const attempt_start = parseInt(attempt.attempt_start_timestamp);
          const duration = parseInt(test.duration) * 60;
          const finalEnd = Math.min(
            attempt_start + duration,
            parseInt(attempt.test_end_timestamp)
          );
          leftTime = finalEnd - server_ts;
        } else {
          if (parseInt(test.duration) > 0) {
            const attempt_start = parseInt(attempt.attempt_start_timestamp);
            const duration = parseInt(test.duration) * 60;
            leftTime = attempt_start + duration - server_ts;
          } else {
            leftTime = -2;
          }
        }
      }

      setLeftTimeToSubmit(leftTime);
      const timerStr =
        Math.floor(leftTime / 3600) +
        " : " +
        ("0" + (Math.floor(leftTime / 60) % 60)).slice(-2) +
        " : " +
        ("0" + (leftTime % 60)).slice(-2);
      setTimerText(timerStr);

      const isPractice = testType === 2;
      const isSectionwise = test?.is_neet_test === 1 && test?.is_sec_time === 1;
      if (isPractice && !isSectionwise && parseInt(test.duration) > 0) {
        startTimer(leftTime);
      }
    };

    if (overrideTimestamp) {
      processTime(overrideTimestamp);
    } else {
      const request = {
        url: `/v1/examPanel/time`,
        headers: {
          "X-Device-Info": "...",
          "X-Device-Key": "ozfinggcn7",
        },
      };
      api.getAuth(request).then((res) => {
        processTime(parseInt(res.data.timestamp));
      });
    }
  };

  useEffect(() => {
    const sections = props.state.subjects_data.map(
      (el) => `${el.subject_id}#${el.section_id}`
    );
    setAllSection(sections);

    if (props.state.start_time) {
      ServerTime(parseInt(props.state.start_time));
    } else {
      ServerTime();
    }
  }, []);

  const test = props.state?.test_data;
  const isMockTest = test?.test_type_id === 1;
  const isPracticeTest = test?.test_type_id === 2;
  const isOnlineTest = test?.test_type_id > 2;
  const isDurationZero = parseInt(test?.duration || "0") === 0;
  const isSectionwise = test?.is_neet_test === 1 && test?.is_sec_time === 1;
  const shouldShowTimer =
    !(isMockTest && isDurationZero) &&
    !(isPracticeTest && isDurationZero);

  return (
    <>
      {leftTimeSubmit === 0 && <SubmitStatus />}

      {props?.state?.test_settings?.is_show_timer === 1 && shouldShowTimer && (
        <>
          {isPracticeTest && isSectionwise && (
            <IitSectionTimer allSection={allSection} />
          )}

          {(isOnlineTest || (isMockTest && !isDurationZero)) && (
            <IitSectionTimer allSection={allSection} />
          )}

          {isPracticeTest && !isSectionwise && !isDurationZero && (
            <div className="timerDiv">
              <span className="timeHeader">Time Left : </span>
              {timerText ? (
                <div style={{ display: "flex" }}>
                  <div className="timerun">{timerText.split(":")[0]}</div>
                  <span style={{ margin: "0 5px" }}>:</span>
                  <div className="timerun">{timerText.split(":")[1]}</div>
                  <span style={{ margin: "0 5px" }}>:</span>
                  <div className="timerun">{timerText.split(":")[2]}</div>
                </div>
              ) : (
                <span className="loading-timer">Loading...</span>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  state,
});

export default connect(mapStateToProps)(Timer);
